import React from 'react';
import { CgClose } from "react-icons/cg";

const Popup = ({ isOpen, onClose, children }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="popup">
      <img className='logo-landing mb-5 pb-2' width={'80%'} src='/images/logo.png' alt=''/>
      <div className="popup-content">
        <a className="close-button" onClick={onClose}>
          {/* <img className='icon-back' src='/images/icon-back.png' alt=''/> */}
          <CgClose />
        </a>
        {children}
      </div>
    </div>
  );
};

export default Popup;
